import tw from 'tailwind-styled-components'

const dialogPanel = `
w-full
max-w-[838px]
h-[659px] 
transform 
overflow-hidden 
rounded-2xl 
bg-white 
p-8 
text-left 
align-middle 
shadow-xl 
transition-all
`

const dialogTitle = `
text-lg 
font-medium 
leading-6 
text-gray-900
flex
justify-between
items-center
`

const Body = tw.div``

export const RulesContainer = tw.div`
w-full
bg-white
border
border-gray-200
rounded-lg
p-6
text-left
mb-6
pl-8
`

export const RulesTitle = tw.h4`
text-base
font-semibold
text-darkGray
mb-2
`

export const RulesList = tw.ul`
space-y-1
text-sm
text-darkGray
list-disc
pl-8
`

export const ButtonAction = tw.button`
inline-flex
items-center
justify-center
h-[38px]
w-[210px]
py-2
px-4
border
border-blueTheme
rounded-lg
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`

export { dialogPanel, dialogTitle, Body } 